import { Component, OnInit } from '@angular/core';
import { ProductSearchPage } from '@spartacus/core';
import { ProductListComponentService, ViewConfig } from '@spartacus/storefront';
import { Observable } from 'rxjs';

@Component({
  selector: 'cx-plp-pagination',
  templateUrl: './plp-pagination.component.html',
  styleUrl: './plp-pagination.component.scss',
  standalone: false,
})
export class PlpPaginationComponent implements OnInit {
  isInfiniteScroll: boolean | undefined;
  model$: Observable<ProductSearchPage> = this.productListComponentService.model$;

  constructor(
    private productListComponentService: ProductListComponentService,
    public scrollConfig: ViewConfig,
  ) {}

  ngOnInit(): void {
    this.isInfiniteScroll = this.scrollConfig.view?.infiniteScroll?.active;
  }
}
